export const companyCertificatesTranslation = {
  en: {
    home: "Home",
    settings: "Settings",
    landing: "Landing",
    companyCertificate: "Company Certificate",
    addCertificate: "Add Certificate",
    editCertificate: "Edit Certificate",
    updateCertificate: "Update Certificate",
    addNewCertificate: "Add New Certificate",
    title: "Title",
    certificateURL: "Certificate URL",
    status: "Status",
    certificate: "certificate",
    search: "Search",
    "Are you sure you want to delete certificate '{{title}}'?":
      "Are you sure you want to delete certificate '{{title}}'?",
    actionCannotBeUndone: "This action cannot be undone.",
    cancel: "Cancel",
    delete: "Delete",
  },
  ar: {
    home: "الصفحة الرئيسية",
    settings: "الإعدادات",
    landing: "الموقع التعريفي",
    companyCertificate: "شهادة الشركة",
    addCertificate: "إضافة شهادة",
    editCertificate: "تحرير الشهادة",
    updateCertificate: "تحديث الشهادة",
    addNewCertificate: "إضافة شهادة جديدة",
    title: "العنوان",
    certificateURL: "رابط الشهادة",
    status: "الحالة",
    certificate: "شهادة",
    search: "بحث",
    "Are you sure you want to delete certificate '{{title}}'?":
      "هل أنت متأكد أنك تريد حذف الشهادة '{{title}}'؟",
    actionCannotBeUndone: "لا يمكن التراجع عن هذا الإجراء.",
    cancel: "إلغاء",
    delete: "حذف",
  },
};
